module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-728a62c0!./packages/dof-tab-page/colmo.css
// module id = 516
// module chunks = 0 1